export default __webpack_public_path__ + "static/media/trigger_circle.79ce4fa0.svg";